module.exports = __webpack_public_path__ + "img/box_pro_four_4.68244822.jpg";